import { NgModule, ModuleWithProviders } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { IcosSelectModule } from '../select/module'
import { IcosPaginationButton, IcosPaginationPager, IcosPaginationSize, IcosPaginationJump } from './children'
import { IcosPagination } from './pagination'


@NgModule({
  declarations: [
    IcosPagination,
    IcosPaginationButton,
    IcosPaginationPager,
    IcosPaginationSize,
    IcosPaginationJump,
  ],
  exports: [IcosPagination],
  imports: [CommonModule, FormsModule, IcosSelectModule],
  entryComponents: [IcosPagination],
})
export class IcosPaginationModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosPaginationModule, providers: [] }
  }
}
